import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import StationMenuItem from './StationMenuItem'
import { logoutDiscoveryStation } from './services'
import StationDrawer from './StationDrawer'
import { useExperienceDataStatus, useKioskIdle } from './hooks'
import setCookie from '../../helpers/cookie'

const outerCSS = css`
  display: flex;
  justify-content: space-between;
`

const menuCSS = css`
  display: flex;
  align-items: center;
  padding-left: 40px;
`
const titleCSS = css`
  font-family: museo;
  margin-left: 40px;
  font-size: 25px;
  color: #989898;
`

export default function StationMenu({ activeExperienceId, isAuthenticated }) {
  const warnMissingConfig = () => {
    // eslint-disable-next-line no-alert
    alert('Unable to find session configuration information!')
  }

  const conf = JSON.parse(sessionStorage.getItem('FS.ds-config'))
  const azUserSessionId = sessionStorage.getItem('userSessionId')

  if (!conf || !azUserSessionId) {
    warnMissingConfig()
  }

  const logout = (email = '') => {
    logoutDiscoveryStation({ azUserSessionId, email }).then(() => {
      setCookie('fssessionid', '') // Clear out previous user session
      window.location.href = conf.discoveryStationHomeURL
    })
  }

  useKioskIdle(conf.timeOut, () => {
    logoutDiscoveryStation({ azUserSessionId, email: '' }).then(() => {
      logout()
    })
  })

  const setInitialNavItemReadyStates = (cfg) => {
    cfg.navMenu.forEach((e) => {
      if (e.id === 'discover' || e.id === 'replaceFace' || e.id === 'explore') {
        e.ready = true
      } else if (isAuthenticated && (e.id === 'compare' || e.id === 'compareCelebrity')) {
        e.ready = true
      } else {
        e.ready = false
      }
    })
  }

  setInitialNavItemReadyStates(conf)
  const [navMenu, setNavMenu] = useState(conf.navMenu)

  const activeExperience = navMenu.find((item) => {
    return item.id === activeExperienceId
  })
  const [t] = useTranslation()
  const experienceDataSatus = useExperienceDataStatus(azUserSessionId)
  const tmpNavMenu = [...navMenu]
  useEffect(() => {
    if (experienceDataSatus.getPersonAncestry === 'Complete') {
      const rfMenuItem = tmpNavMenu.find((item) => item.id === 'relativeFinder')
      if (!rfMenuItem.ready) {
        rfMenuItem.ready = true
        setNavMenu(tmpNavMenu)
      }
    }
  }, [experienceDataSatus, navMenu, tmpNavMenu])

  const getLabel = (id) => {
    let translatedLabel = ''
    switch (id) {
      case 'discover': {
        translatedLabel = t('station-menu.all-about-me', 'All About Me')
        break
      }
      case 'explore': {
        translatedLabel = t('station-menu.where-am-i-from', 'Where am I from?')
        break
      }
      case 'relativeFinder': {
        translatedLabel = t('station-menu.relative-finder', 'My Famous Relatives')
        break
      }
      case 'replaceFace': {
        translatedLabel = t('station-menu.picture-my-heritage', 'Picture My Heritage')
        break
      }
      case 'compareCelebrity':
      case 'compare': {
        translatedLabel = t('station-menu.compare-a-face', 'Compare-a-Face')
        break
      }
      default:
        break
    }
    return translatedLabel
  }

  return (
    <>
      <div css={outerCSS}>
        <div css={menuCSS}>
          {navMenu.map((menuItem) => (
            <StationMenuItem
              isAuthenticated={isAuthenticated}
              key={menuItem.id}
              menuItem={menuItem}
              isActive={menuItem.id === activeExperience.id}
            />
          ))}
        </div>
        <StationDrawer logoutCallback={logout} />
      </div>
      <div css={titleCSS}>{getLabel(activeExperience.id)}</div>
      <div css={{ backgroundColor: activeExperience.color, height: '20px' }} />
    </>
  )
}

StationMenu.propTypes = {}
